<template>
    <v-container fluid class="mx-0 px-0 my-0 py-0">
        <v-row class="team-banner secondary-font" :style="`background: linear-gradient(90deg, ${match.team1Score > match.team2Score ? (match.team1?.color ? match.team1?.color : 'teal') : '#bbb7b6'} 50%, ${match.team2Score > match.team1Score ? (match.team2?.color ? match.team2?.color : 'teal') : '#bbb7b6'} 50%);`" justify="center" align="center">
            <v-col cols="4" md="4" class="pb-0 mb-0 clickable" @click.stop="goToTeam(match.team1)">
                <v-avatar style="border-radius: 10px;" :size="$vuetify.breakpoint.mobile ? 100 : 150" color="white">
                    <v-img
                        :src="`${assetsUrl}/${match.team1?.logo}`"
                        height="150px"
                        contain
                    />
                </v-avatar>
            </v-col>
            <v-col v-if="match.team1Score > 0 || match.team2Score > 0" cols="4" md="2" align="center" class="score-dashboard  px-1">
                <v-row align="center" justify="center" class="my-0 mx-0 px-0 py-0">
                    <span
                        :class="match.team1Score > match.team2Score ? 'winning-score' : ''"
                    >
                        <span class="white--text font-weight-bold" :class="!$vuetify.breakpoint.mobile ? 'text-h2' : 'text-h4'">{{ match.team1Score }}</span>
                    </span>
                    <span>
                        <v-divider
                            vertical
                            color="white"
                            class="custom-divider mx-2"
                        />
                    </span>
                    <span
                        :class="match.team2Score > match.team1Score ? 'winning-score' : ''"
                    >
                        <span class="white--text font-weight-bold" :class="!$vuetify.breakpoint.mobile ? 'text-h2' : 'text-h4'">{{ match.team2Score }}</span>
                    </span>
                </v-row>
            </v-col>
            <v-col v-else cols="4" md="2" align="center" class="score-dashboard ">
                <span class="text-h3 custom-teal-text font-weight-bold">VS</span>
            </v-col>
            <v-col cols="4" md="4" class="pb-0 mb-0 clickable" @click.stop="goToTeam(match.team2)">
                <v-avatar style="border-radius: 10px;" :size="$vuetify.breakpoint.mobile ? 100 : 150" color="white">
                    <v-img
                        v-if="match.team2.logo"
                        :src="`${assetsUrl}/${match.team2?.logo}`"
                        height="150px"
                        contain
                    />
                    <v-icon v-else :style="$vuetify.breakpoint.mobile ? 'font-size: 80px' : 'font-size: 120px'" class="teal--text"> mdi-basketball-hoop </v-icon>
                </v-avatar>
            </v-col>
            <v-col cols="12" align="center" class="my-0 py-0 text-subtitle-1 secondary-font">
                <span v-if="!match.cup"> {{ getMatchTitle() }}, </span>
                <span>
                    {{ (match.round > 0 ? ('Matchday ' + match.round + ', ') : '') + (match.cup ? 'Κύπελλο' : (match.phase === 'regular_season' ? 'Regular Season' : (match.phase === 'playoffs' ? 'Play Offs' : 'Match'))) }}
                </span>
            </v-col>
            <v-col cols="12" align="center" class="text-subtitle-1 secondary-font py-0 my-0 pb-4">
                {{ getDate(match.matchDatetime) }}
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    export default {
        props: {
            match: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                team: {},
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        methods: {
            getMatchTitle() {
                if (this.match.cupLeague) {
                    return this.match.cupLeague.title
                } else if (this.match.league) {
                    return this.match.league.title
                } else {
                    return 'Friendly'
                }
            },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').locale('el-GR').format('dddd D/M/y, HH:mm').toString()
            },
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style scoped>
.score-text {
    font-size: 4rem;
}

.winning-score {
    background: linear-gradient(#00f7d1, #00ec80);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.score-dashboard {
    background-color: #00000091;
}

.team-name {
    font-size: 2.2rem;
    font-weight: 800;
}

.win-lose-score {
    font-size: 2.2rem;
    font-weight: 800;
}

.win-lose-text {
    font-size: 1rem;
}

.custom-divider {
    border-width: 2px;
    height: 40px;
}

.team-banner {
    color: white;
    font-size: 1.5rem;
    background: linear-gradient(160deg, teal 50%, #bbb7b6 50%);
}
</style>
